import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../CSS/Candidatefile.css";
import { useLocation } from "react-router-dom";
import ArchivedModal from "../../components/Modal/ArchivedModal";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PreModal from "../../components/Modal/preSelectedModal";
import ProfileLoader from "../../components/Loader/ProfilesLoader";
import { API_BASE_URL } from "../../config/serverApiConfig";
import { Toaster, toast } from "react-hot-toast";
import "react-multi-carousel/lib/styles.css";
import axios from "axios";
import ReadMoreReact from "read-more-react";
import PDFGenerate from "../../components/Modal/PDFGenerateModal";
import ErrorLoader from "../../components/Loader/SearchBarError";
import DOCUSIGNModalCandidate from "../../components/Modal/DOCUSIGNModalCandidate";
import PDFBoxCandidate from "../../components/PDFboxBothSide/PDFBoxCandidate";
import InProgressModal from "../../components/Modal/InProgressModal";
import Representance from "../../components/Modal/RepresentanceModalCandidate";
import AvanceModal from "../../components/Modal/AvanceModalCandidate";
import CandidateContract from "../../components/CandidateComponents/CandidateContract";
import DocumLink from "../../components/Modal/CandidateRepresentModal/LinkModal";
import { Tabs, Tab } from "react-tabs-scrollable";
import ViewPageDetailsBox from "../../components/CandidateComponents/ViewPageDetailsBox";
import RemoveCandidatPermanentlyModal from "../../components/candidate/modals/delete-candidate/removeCandidatePermanently";
import SocialButtons from "../../components/CandidateComponents/ViewPageSocialButtons";
import Cookies from "js-cookie";
import Select from "react-select";
import "react-tabs-scrollable/dist/rts.css";
import "../../CSS/Client/ArchivedCardClient.css";

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
});

function CandidateProfile() {

    const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));

    const { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [profile, setProfile] = useState<any>(null);
    const [Client, setClients] = useState([]) as any;
    const [showPermanentlyDeleteModal, setShowPermanentlyDeleteModal] = useState(false);
    const [showPreSelectedModal, setShowInPreSelectedModal] = useState(false);
    const [showArchiveModal, setShowArchiveModal] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [recommendations, setRecommendations] = useState([]);
    const [loader, setLoader] = useState(false);
    const hiddenImageInput = React.useRef(null);
    const [representance, setRepresentance] = useState(false);
    const [Avance, setAvance] = useState(false);
    const [docUploaded, setDocUploaded] = useState(false);
    const [UploadBtn, setSelectUpload] = useState(false);
    const [showInProgressModal, setShowInProgressModal] = useState(false);
    const [PDFModal, setPDFModal] = useState(false);
    const [DocumentSignModal, setDocuSignModal] = useState(false);
    const [DocuLink, setDocuLink] = useState(false);
    const [ReAvance, setReAvance] = useState("");
    const [repID, setRepId] = useState("");
    const [CONTRACT_EMPLOYE_INTERMANN] = useState() as any;
    const [Fiche_Medicale] = useState() as any;
    const [Assurance] = useState() as any;
    const [ID_CARD] = useState() as any;
    const [Reges] = useState() as any;
    const [Fiche_mise_à_disposition] = useState() as any;
    const [startStatus, setStartStatus] = useState();
    const [endStatus, setEndStatus] = useState();
    const [startDate, setStartDate] = useState() as any;
    const [EndDate, setEndDate] = useState() as any;
    const [editOptions, setEditOptions] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState();
    const [clientProfile, setClientProfile] = useState() as any;
    const [isProfileLoaded, setIsProfileLoaded] = useState(false);
    const [tempCandidateName, setTempCandidateName] = useState('');

    function padTo2DigitsCH(num) {
        return num.toString().padStart(2, "0");
    }

    function formatDateCha(date) {
        return [
            padTo2DigitsCH(date.getDate()),
            padTo2DigitsCH(date.getMonth() + 1),
            date.getFullYear(),
        ].join("/");
    }

    const onTabClick = (e, index) => {
        console.log(e);
        setActiveTab(index);
    };

    const fetchProfilesClients = async () => {
        return await fetch(API_BASE_URL + "allToDoClients", {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
            },
        })
            .then((resD) => resD.json())
            .then((res) => res)
            .catch((err) => err);
    };

    const removeRecommendation = (rId: any) => {
        let filteredRecommendations = recommendations.filter((recomm) => {
            return recomm._id !== rId;
        });
        setRecommendations([...filteredRecommendations]);
        setLoader(true);
    };

    const fetchRecommendations = async (candidatSector: string) => {
        return await fetch(
            API_BASE_URL + `clientRecommendations/?candidatSector=${candidatSector}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
            }
        )
            .then((resp) => resp.json())
            .then((respData) => respData)
            .catch((err) => err);
    };

    const editCandidatProfile = () => {
        let data = { profileData: profile, path: `/candidate/profile/${profile._id}` };
        navigate(`/candidate/edit/${profile._id}`, { state: data });
    };

    const deleteCandidatePermanently = () => {
        setShowPermanentlyDeleteModal(true);
    }

    useEffect(() => {
        setLoader(true);
        if (!isProfileLoaded) {
            fetchCandidat(id)
                .then((resData) => {
                    console.log(resData);
                    if (resData.status) {
                        setProfile(resData.data);

                        setStartStatus(resData.data.candidatStartDate !== undefined
                            ? resData.data.candidatStartDate.slice(0, 4).includes("-")
                            : null)
                        setSelectedStatus(resData.data.candidatStatus);
                        setEndStatus(
                            resData.data.candidatEndDate !== undefined
                                ? resData.data.candidatEndDate.slice(0, 4).includes("-")
                                : null
                        );
                        setDocUploaded(false);
                        let start = new Date(resData.data.candidatStartDate);
                        let end = new Date(resData.data.candidatEndDate);

                        if (startStatus) {
                            setStartDate(resData.data.candidatStartDate);
                        } else {
                            let data = formatDateCha(start);
                            setStartDate(data.replaceAll("/", "-"));
                        }
                        if (endStatus) {
                            setEndDate(resData.data.candidatEndDate);
                        } else {
                            let data = formatDateCha(end);
                            setEndDate(data.replaceAll("/", "-"));
                        }
                    } else {
                        setDocUploaded(false);
                    }
                    setIsProfileLoaded(true);
                    setLoader(false);
                })
                .catch((err) => {
                    console.log(err);
                });

            if (Client.length === 0) {
                fetchProfilesClients().then((res) => setClients([...res]));
            }
        }
    });

    const fetchCandidat = async (candidatId: any) => {
        return await fetch(
            API_BASE_URL + `getCandidatById/?candidatId=${candidatId}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
            }
        )
            .then((resp) => resp.json())
            .then((respData) => respData)
            .catch((err) => err);
    };

    useEffect(() => {
        setLoader(true);
        if (profile) {
            fetchRecommendations(profile.candidatActivitySector)
                .then((respData) => {
                    if (respData.status) {
                        setRecommendations([...respData.data]);
                        setProfile((prev) => ({ ...prev, ["clients"]: [...recommendations] }));
                        setLoader(true);
                    } else {
                        setRecommendations([]);
                        setLoader(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [isProfileLoaded, state]);

    const showCustomerProfile = () => {
        localStorage.setItem("profile", JSON.stringify(profile));
        window.open("/clientSignedGlobalCard", "_blank");
    };

    const fetchClientProfile = async (name: string) => {
        return await fetch(
            API_BASE_URL + `getClientByName/?clientCompanyName=${name}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
            }
        )
            .then((resD) => resD.json())
            .then((reD) => reD)
            .catch((err) => err);
    };

    useEffect(() => {
        if (profile) {
            if (clientProfile === undefined && profile.candidatStatus === "Hired") {
                if (clientProfile) {
                    return;
                } else {
                    fetchClientProfile(profile.candidatCurrentWork[0].workingFor).then(
                        (result) => {
                            if (result.status) {
                                setClientProfile(result.data);
                            }
                        }
                    );
                }
            }
        }
    }, [isProfileLoaded, profile]);

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const transferCandidatToRIS = async () => {
        try {
            const response = await fetch(API_BASE_URL + 'transferToRIS', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
                body: JSON.stringify({
                    candidatId: profile._id,
                }),
            });

            if (!response.status) {
                console.log('Error transferring candidat to RIS');
                toast.error('Error transferring candidat to RIS');
            }
            const data = await response.json();
            console.log('Candidat transferred to RIS successfully', data);
            toast.success('Candidat transferred to RIS successfully!');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.error('Error transferring candidat to RIS:', error);
        }
    }

    return (
        <>
            <Toaster
                position="top-right"
                containerStyle={{ zIndex: "99999999999" }}
            />
            {
                profile ?
                    (<div className="container-fluid tw-py-2">
                        <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-flex tw-justify-between tw-my-4 tw-p-4 tw-items-center">
                            {
                                LoginUser?.username === 'PJ Darche' ?
                                    <Link to="/ris-candidates/">
                                        <button
                                            type="button"
                                            className="btn tw-flex tw-items-center tw-space-x-2"
                                        >
                                            <img
                                                alt="back button"
                                                title="Back to Candidates List"
                                                src={require("../../images/return.svg").default}
                                            />
                                            <h2 className="card-Leads mb-0">Profile: {profile.candidatName}</h2>
                                        </button>
                                    </Link> :
                                    <Link to="/candidates/">
                                        <button
                                            type="button"
                                            className="btn tw-flex tw-items-center tw-space-x-2"
                                        >
                                            <img
                                                alt="back button"
                                                title="Back to Candidates List"
                                                src={require("../../images/return.svg").default}
                                            />
                                            <h2 className="card-Leads mb-0">Profile: {profile.candidatName}</h2>
                                        </button>
                                    </Link>
                            }


                            <div className="tw-flex tw-justify-end tw-items-center tw-space-x-2">
                                {
                                    profile.transferredToRIS ? <button className="tw-flex tw-items-center tw-space-x-2 tw-py-2 tw-bg-[#032339] tw-text-white tw-rounded-full tw-px-6 tw-font-bold tw-h-auto hover:tw-shadow-xl">
                                        Transferred To RIS
                                    </button> : <button onClick={transferCandidatToRIS} className="tw-flex tw-items-center tw-space-x-2 tw-py-2 tw-bg-[#032339] tw-text-white tw-rounded-full tw-px-6 tw-font-bold tw-h-auto hover:tw-shadow-xl">
                                        Transfer To RIS
                                    </button>
                                }


                                {LoginUser?.username === 'PJ Darche' ? null : <button className="tw-flex tw-items-center tw-space-x-4 tw-py-2 tw-bg-[#032339] tw-text-white tw-rounded-xl tw-px-4 tw-font-bold tw-h-auto hover:tw-shadow-xl"
                                    onClick={editCandidatProfile}>
                                    <img alt="..." src={require("../../images/Edit.svg").default} />
                                    <span>Edit Profile</span>
                                </button>}

                                {LoginUser?.username === 'PJ Darche' ? null : <button className="tw-flex tw-items-center tw-space-x-2 tw-py-2 tw-bg-white tw-border-[1px] tw-border-red-500 tw-text-red-500 tw-rounded-xl tw-px-4 tw-font-bold tw-h-auto hover:tw-shadow-xl"
                                    onClick={deleteCandidatePermanently}>
                                    <img alt="..." src={require("../../images/delete.svg").default} />
                                    <span className="tw-uppercase tw-text-lg">DELETE</span>
                                </button>}
                            </div>
                        </div>

                        <CandidateProfileInfo
                            profile={profile}
                            editCandidatProfile={editCandidatProfile}
                            editOptions={editOptions}
                            setEditOptions={setEditOptions}
                            showInProgressModal={setShowInProgressModal}
                            showArchiveModal={setShowArchiveModal}
                            updateSelectedStatus={setSelectedStatus}
                            showPreSelectedModal={setShowInPreSelectedModal}
                        />

                        {
                            profile.candidatStatus === "Hired" && profile.candidatCurrentWork.length > 0 ? (
                                <div className="tw-rounded-xl tw-flex tw-justify-between tw-items-center tw-shadow-lg tw-bg-[#F4E7FF] tw-p-5 tw-my-2">
                                    <div className="tw-flex tw-flex-col">
                                        <div className="tw-flex tw-w-full tw-items-center space-x-4">
                                            <p className="tw-text-md tw-font-semibold">Working For:</p>
                                            <p className="tw-text-lg tw-mx-2">{profile.candidatCurrentWork[0].workingFor}</p>
                                        </div>
                                        <div className="tw-flex space-x-4 tw-items-center">
                                            <p className="tw-text-md tw-font-semibold">Since:</p>
                                            <p className="tw-text-lg tw-mx-2">{profile.candidatCurrentWork[0].workingSince}</p>
                                        </div>
                                        <div className="tw-flex space-x-4 tw-items-center">
                                            <p className="tw-text-md tw-font-semibold">Salary:</p>
                                            <p className="tw-text-lg tw-mx-2">{profile.candidatCurrentWork[0].salary + "€"}</p>
                                        </div>
                                    </div>

                                    <button className="tw-flex tw-h-fit tw-bg-[#032339] tw-rounded-full tw-items-center tw-space-x-2 tw-px-6 tw-py-2 tw-shadow-lg hover:tw-shadow-2xl" onClick={showCustomerProfile}>
                                        <img alt="..."
                                            src={require("../../images/eyeProfil.svg").default}
                                        />
                                        <span className="tw-text-white tw-uppercase tw-font-semibold">Client Profile</span>
                                    </button>
                                </div>
                            ) : null
                        }

                        <ViewPageDetailsBox
                            props={profile}
                            startDate={startDate}
                            EndDate={EndDate}
                            editCandidatProfile={editCandidatProfile}
                        />

                        <div className="tw-rounded-xl tw-shadow-lg tw-bg-white tw-p-5">
                            <div className="tw-flex tw-justify-between">
                                <h3 className="experience">Candidate Experience:
                                </h3>

                                {LoginUser?.username === 'PJ Darche' ? null : <img className="tw-cursor-pointer" style={{ filter: "invert(1)", height: "22px" }} alt="edit" src={require("../../images/Edit.svg").default} onClick={editCandidatProfile} />}
                            </div>
                            <ExperienceTable profile={profile} editCandidatProfile={editCandidatProfile} />
                        </div>

                        {
                            profile.candidatArchived && profile.candidatArchived.reason ?
                                <div className="tw-rounded-xl tw-shadow-lg tw-bg-white tw-p-5 tw-my-2">
                                    <div className="tw-flex tw-justify-between">
                                        <p className="tw-text-xl tw-text-black tw-font-bold">Reason for <span className="tw-text-red-600">{profile.candidatStatus}</span>:</p>
                                        {LoginUser?.username === 'PJ Darche' ? null : <img className="tw-cursor-pointer" style={{ filter: "invert(1)", height: "22px" }} alt="edit" src={require("../../images/Edit.svg").default} onClick={editCandidatProfile} />}
                                    </div>
                                    <textarea
                                        id="skills"
                                        name="reasonArchived"
                                        className="form-control tw-border-black focus-visible:tw-outline-none"
                                        value={profile.candidatArchived.reason}
                                        rows={4}
                                    >
                                    </textarea>
                                </div> :
                                <div className="tw-my-4">
                                    <Carousel responsive={responsive}>
                                        {recommendations && recommendations.length > 0 ? (
                                            recommendations.map((recommendation) => (
                                                <div
                                                    className="row p-1  m-1 Social-Card client-Card"
                                                    style={{ height: "330px" }}
                                                    key={recommendation}
                                                >
                                                    <div className="col-3">
                                                        <img
                                                            alt="..."
                                                            src={require("../../images/Card-ImageStar.svg").default}
                                                        />
                                                    </div>
                                                    <div className="col-9 d-flex align-items-center">
                                                        <p
                                                            className="mb-0 FontMatchedStyle"
                                                            style={{ marginTop: "-15px" }}
                                                        >
                                                            <b>
                                                                {recommendation.clientCompanyName.length > 20
                                                                    ? recommendation.clientCompanyName
                                                                        .slice(0, 21)
                                                                        .toLocaleUpperCase() + "..."
                                                                    : recommendation.clientCompanyName.toLocaleUpperCase()}
                                                            </b>
                                                        </p>
                                                    </div>

                                                    <p className="mb-0 FontStylingCardtext">
                                                        Secteur :{" "}
                                                        <b>
                                                            {recommendation.clientActivitySector !== ""
                                                                ? recommendation.clientActivitySector.toLocaleUpperCase()
                                                                : "Sector Not Selected!"}
                                                        </b>
                                                    </p>

                                                    <p className="mb-0 FontStylingCardtext">
                                                        Job :{" "}
                                                        <b>
                                                            {recommendation.clientJob !== ""
                                                                ? recommendation.clientJob.toLocaleUpperCase()
                                                                : "Job Not Selected!"}
                                                        </b>
                                                    </p>

                                                    <div className="col-12 mb-1">
                                                        <p className="mb-0 FontStylingCardtext">Notes:</p>
                                                        <div className="mb-0 FontStylingCardtext styledNotes">
                                                            {recommendation.clientRequiredSkills !== "" ? (
                                                                <div style={{ height: "100px" }}>
                                                                    {" "}
                                                                    <ReadMoreReact
                                                                        text={recommendation.clientRequiredSkills}
                                                                        min={0}
                                                                        ideal={50}
                                                                        max={150}
                                                                        readMoreText={"....."}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p
                                                                    style={{ height: "100px" }}
                                                                    className="mb-0 FontStylingCardtext"
                                                                >
                                                                    No Notes/Skills Available!
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-6 text-center d-flex align-items-center justify-content-center px-0">
                                                        <button
                                                            className="btnMatched"
                                                            onClick={() => setShowInPreSelectedModal(true)}
                                                        >
                                                            Matched
                                                        </button>
                                                    </div>
                                                    <div className="col-6 text-center d-flex align-items-center px-0">
                                                        <button
                                                            className="btnNotMatched"
                                                            onClick={() =>
                                                                removeRecommendation(recommendation._id)
                                                            }
                                                        >
                                                            Not Matched
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : loader ? (
                                            <div className="col-12 mx-auto">
                                                <ProfileLoader
                                                    width={"300px"}
                                                    height={"300px"}
                                                    fontSize={"22px"}
                                                    fontWeight={700}
                                                    Title={"Loading.."}
                                                />
                                            </div>
                                        ) : (
                                            <div className="Social-Card m-1 text-center">
                                                No More Client Recommendations!
                                            </div>
                                        )}
                                    </Carousel>
                                </div>
                        }

                        <div className="tw-flex tw-justify-center tw-space-x-4 tw-my-2 tw-items-center tw-rounded-xl tw-shadow-lg tw-bg-white tw-p-5">
                            <button
                                type="button"
                                className="tw-w-1/4 tw-rounded-full tw-bg-white tw-text-[#032339] hover:tw-bg-[#032339] tw-border-[1px] tw-border-[#032339] hover:tw-text-white tw-px-4 tw-py-2 tw-font-bold tw-h-auto hover:tw-shadow-xl"
                                onClick={() => {
                                    setPDFModal(true)
                                }}
                            >
                                Generate A Contract
                            </button>

                            <button
                                type="button"
                                className="tw-w-1/4 tw-rounded-full tw-bg-white tw-text-[#032339] hover:tw-bg-[#032339] tw-border-[1px] tw-border-[#032339] hover:tw-text-white tw-px-4 tw-py-2 tw-font-bold tw-h-auto hover:tw-shadow-xl"
                                onClick={() => {
                                    setRepresentance(true);
                                }}
                            >
                                Generate Representation
                            </button>

                            {PDFModal ? (
                                <PDFGenerate
                                    props={profile}
                                    LinkModal={setDocuSignModal}
                                    closeModal={setPDFModal}
                                    path="/candidate/profile/"
                                />
                            ) : null}
                            {representance ? (
                                <Representance
                                    props={profile}
                                    closeModal={setRepresentance}
                                    rePid={setRepId}
                                    LinkModal={setDocuLink}
                                    setReAvance={setReAvance}
                                    candidateTemporaryName={setTempCandidateName}
                                />
                            ) : null}
                            {Avance ? (
                                <AvanceModal
                                    props={profile}
                                    closeModal={setAvance}
                                    rePid={setRepId}
                                    LinkModal={setDocuLink}
                                    setReAvance={setReAvance}
                                />
                            ) : null}
                        </div>

                        <div className="tw-flex tw-rounded-xl tw-shadow-lg tw-bg-white tw-p-5 tw-flex-wrap tw-my-4">
                            {JSON.stringify(profile).includes(
                                JSON.stringify(profile.candidatContract)
                            ) ? (
                                <>
                                    <CandidateContract props={profile} path={"candidate/edit/" + profile._id} />
                                </>
                            ) : (
                                <div className="col-12 d-flex justify-content-center align-items-center py-2 noData">
                                    <ErrorLoader />
                                    <p className="mb-0 ErrorSearchBox ">
                                        ✘ No Contract Available for this Candidat! Please add a
                                        New Contract ✘
                                    </p>
                                </div>
                            )}
                        </div>

                        <PDFBoxCandidate props={profile} value={setProfile} />

                        {DocuLink ? (
                            <DocumLink
                                props={profile}
                                closeModal={setDocuLink}
                                id={repID}
                                ReAvance={ReAvance}
                                candidateTemporaryName={tempCandidateName}
                            />
                        ) : null}

                        {DocumentSignModal ? (
                            <DOCUSIGNModalCandidate
                                props={profile}
                                closeModal={setDocuSignModal}
                            />
                        ) : null}

                        {showInProgressModal ? (
                            <InProgressModal
                                props={profile}
                                closeModal={setShowInProgressModal}
                            />
                        ) : null}

                        {showArchiveModal ? (
                            <ArchivedModal
                                props={profile}
                                closeModal={setShowArchiveModal}
                                path={"/candidate/profile/" + profile._id}
                                status={selectedStatus}
                            />
                        ) : null}

                        {showPreSelectedModal ? (
                            <PreModal
                                props={profile}
                                closepreModal={setShowInPreSelectedModal}
                            />
                        ) : null}

                        {showPermanentlyDeleteModal ? (
                            <RemoveCandidatPermanentlyModal
                                props={profile}
                                closeModal={setShowPermanentlyDeleteModal}
                                path={'/candidates'}
                            />
                        ) : null}

                        <div className="alertMessage align-items-center py-1">
                            <Tabs
                                rightBtnIcon={">"}
                                hideNavBtns={false}
                                leftBtnIcon={"<"}
                                showTabsScroll={false}
                                tabsScrollAmount={1}
                                activeTab={activeTab}
                                onTabClick={onTabClick}
                            >
                                {CONTRACT_EMPLOYE_INTERMANN ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️ CONTRACT EMPLOYE INTERMANN IS MISSING / MANQUANT
                                    </Tab>
                                )}
                                {ID_CARD ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️ ID CARD IS MISSING / MANQUANT
                                    </Tab>
                                )}
                                {Fiche_Medicale ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️FICHE MEDICALE IS MISSING / MANQUANT
                                    </Tab>
                                )}
                                {Assurance ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️ ASSURANCE IS MISSING / MANQUANT
                                    </Tab>
                                )}
                                {Reges ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️ REGES IS MISSING / MANQUANT
                                    </Tab>
                                )}
                                {Fiche_mise_à_disposition ? null : (
                                    <Tab className="redColorStyling">
                                        ⚠️ FICHE MISE A DISPOSITION IS MISSING / MANQUANT
                                    </Tab>
                                )}
                            </Tabs>
                        </div>
                    </div>)
                    : null
            }
        </>
    );
}
export default CandidateProfile;

export const CandidateProfileInfo = ({ profile, showInProgressModal, editCandidatProfile, editOptions, setEditOptions, showArchiveModal, updateSelectedStatus, showPreSelectedModal }) => {
    const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
    const renderProfileInfo = (label, value) => (
        <div className="tw-flex tw-items-center tw-space-x-1">
            <span className="tw-font-bold">{label}: </span>
            <span className="tw-flex tw-space-x-2">
                <span className="tw-text-lg">{value || `No ${label}!`}</span>
                {LoginUser?.username === 'PJ Darche' ? null : <img className="tw-cursor-pointer" style={{ filter: "invert(1)", height: "22px" }} alt="edit" src={require("../../images/Edit.svg").default} onClick={editCandidatProfile} />}
            </span>
        </div>
    );

    return (
        <div
            className="tw-flex tw-bg-white tw-rounded-xl tw-shadow-lg tw-w-full tw-justify-between tw-p-4"
        >
            <div className="tw-flex tw-w-[100%] tw-space-x-4">
                {/* Candidate Information */}
                <div className="tw-flex tw-flex-col">
                    <div className="tw-flex tw-space-x-1">
                        <p className="tw-text-lg tw-font-semibold">
                            {profile.candidatName.toLocaleUpperCase()} | {profile.candidatAge || "0"}
                        </p>
                        <span className="card-xlSpan">(Age)</span>
                    </div>

                    {renderProfileInfo("Sector", profile.candidatActivitySector?.toLocaleUpperCase())}
                    {renderProfileInfo("Profession", profile.candidatJob?.toLocaleUpperCase())}
                    {renderProfileInfo("Phone Number", profile.candidatPhone?.toLocaleUpperCase())}
                    {renderProfileInfo("Email", profile.candidatEmail?.toLocaleUpperCase())}
                </div>
            </div>

            {/* Status Change */}
            <StatusButtons profile={profile} showInProgressModal={showInProgressModal} showCollectingDocsModal={showPreSelectedModal} editOptions={editOptions} setEditOptions={setEditOptions} showArchiveModal={showArchiveModal} changeSelectedStatus={updateSelectedStatus} />
        </div>
    );
};

export const StatusButtons = ({ profile, editOptions, setEditOptions, showInProgressModal, showArchiveModal, changeSelectedStatus, showCollectingDocsModal }) => {
    const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
    const _statusOptions = [
        { value: "New", label: "NEW" },
        { value: "No Answer", label: "NO ANSWER" },
        { value: "Contacted", label: "CONTACTED" },
        { value: "Interested", label: "INTERESTED" },
        { value: "Collecting Docs", label: "COLLECTING DOCS" },
        { value: "Hired", label: "HIRED" },
        { value: "Fired", label: "FIRED" },
        { value: "Denied", label: "DENIED" },
        { value: "Finished", label: "FINISHED" },
        { value: "Dead Lead", label: "DEAD LEAD" },
    ];

    const statusOptions = _statusOptions.filter((option) => option.value !== profile.candidatStatus);

    const statusBgColor = {
        "New": "#E5EEFF",
        "No Answer": "#FFE1E1",
        "Contacted": "#6FCB94",
        "Interested": "#FEF1E1",
        "Collecting Docs": "#ECF4FF",
        "Pre-Selected": "#ECF4FF",
        "In-Progress": "#DDFFEA",
        "To-Do": "#E5EEFF",
        "Hired": "#DDFFEA",
        "Fired": "#FFE1E1",
        "Denied": "#FFE1E1",
        "Finished": "#ECECEC",
        "Archived": "#FFE1E1",
        "Dead Lead": "#ECECEC",
    };

    const statusTextColor = {
        "New": "#3F76E2",
        "No Answer": "#E21B1B",
        "Contacted": "#FFFFFF",
        "Interested": "#FE8700",
        "Collecting Docs": "#31435B",
        "Pre-Selected": "#31435B",
        "In-Progress": "#489767",
        "To-Do": "#3F76E2",
        "Hired": "#489767",
        "Fired": "#E21B1B",
        "Denied": "#E21B1B",
        "Finished": "#000000",
        "Archived": "#E21B1B",
        "Dead Lead": "#000000",
    };

    const bgColor = statusBgColor[profile.candidatStatus];
    const buttonTextColor = statusTextColor[profile.candidatStatus];

    const handleStatusChange = async (status) => {
        changeSelectedStatus(status);
        if (status === "Hired") {
            showInProgressModal(true);
            setEditOptions(false);
            return;
        }

        if (["Fired", "Denied", "Dead Lead"].includes(status)) {
            showArchiveModal(true);
            setEditOptions(false);
            return;
        }

        if (status === "Collecting Docs") {
            showCollectingDocsModal(true);
            setEditOptions(false);
            return;
        }

        try {
            const response = await fetch(API_BASE_URL + 'changeStatus', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
                body: JSON.stringify({
                    candidatId: profile._id,
                    status: status,
                }),
            });

            if (!response.status) {
                console.log('Error updating status');
                toast.error('Error updating status');
            }
            const data = await response.json();
            console.log('Status updated successfully', data);
            toast.success('Status updated successfully!');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.error('Error updating status:', error);
        } finally {
            setEditOptions(false);
        }
    };

    return (<>
        <div className="tw-flex tw-items-center tw-flex-col tw-space-y-2 tw-justify-center">
            <div className="tw-flex tw-items-center tw-justify-center tw-space-x-2">
                <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
                    <button className="tw-px-4 tw-py-2 tw-rounded-full tw-font-bold tw-border-0 tw-whitespace-nowrap" style={{ backgroundColor: bgColor, color: buttonTextColor }}>
                        {profile.candidatStatus}
                    </button>
                    {profile.candidatArchived ?
                        <span className="tw-text-sm tw-font-medium tw-text-center tw-whitespace-normal">
                            ({profile.candidatArchived.reason.toLocaleUpperCase()})
                        </span>
                        :
                        null
                    }
                </div>

                <div className="tw-relative tw-flex tw-items-center tw-justify-center">
                    {LoginUser?.username === 'PJ Darche' ? null : <button className="tw-flex tw-items-center tw-space-x-2 tw-py-2 tw-bg-[#032339] tw-text-white tw-rounded-full tw-px-6 tw-font-bold tw-h-auto hover:tw-shadow-xl" onClick={() => setEditOptions(!editOptions)}>
                        <img alt="..." src={require("../../images/Edit.svg").default} />
                        <span className="tw-text-sm tw-whitespace-nowrap">Change Status</span>
                        {
                            editOptions ?
                                <svg style={{ marginLeft: "5px" }} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 15 7-7 7 7" />
                                </svg>
                                :
                                <svg style={{ marginLeft: "5px" }} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7" />
                                </svg>
                        }
                    </button>}

                    {editOptions && (
                        <div className="tw-absolute tw-top-full tw-mt-2 tw-w-48 tw-bg-white tw-rounded-lg tw-shadow-lg tw-z-10">
                            <ul className="tw-py-2">
                                {statusOptions.map((option, index) => (
                                    <li key={index}>
                                        <button
                                            className="tw-w-full tw-text-left tw-px-4 tw-py-2 hover:tw-bg-gray-100"
                                            onClick={() => {
                                                handleStatusChange(option.value);
                                            }}
                                        >
                                            {option.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>)
}

export const ExperienceTable = ({ profile, editCandidatProfile }) => {
    const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
    const hasExperience = profile.candidatExperienceDetails.length > 0 && profile.candidatExperienceDetails[0].period !== "";

    return (
        <table className="table table-bordered border-dark tw-rounded-lg">
            <thead>
                <tr>
                    <th scope="col">Period</th>
                    <th scope="col">Workplace</th>
                    <th scope="col">Job</th>
                </tr>
            </thead>
            <tbody>
                {hasExperience ? (
                    profile.candidatExperienceDetails.map((detail) => (
                        <tr key={detail.period}>
                            <td>{detail.period}</td>
                            <td>{detail.location}</td>
                            <td>{detail.workDoneSample}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={3} className="text-center">
                            <b className="d-flex align-items-center justify-content-center my-1 noData">
                                <ErrorLoader />
                                No Experience Details Available!
                            </b>
                            {LoginUser?.username === 'PJ Darche' ? null : <button
                                className="btn btn-sm text-light btn-dark"
                                onClick={editCandidatProfile}
                            >
                                Edit Candidate To Add Experience Details!
                            </button>}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export function EditOptions({ closeModal }) {
    const statusOptions = [
        { value: "new", label: "NEW" },
        { value: "no_answer", label: "NO ANSWER" },
        { value: "contacted", label: "CONTACTED" },
        { value: "interested", label: "INTERESTED" },
        { value: "collecting_docs", label: "COLLECTING DOCS" },
        { value: "hired", label: "HIRED" },
        { value: "fired", label: "FIRED" },
        { value: "denied", label: "DENIED" },
        { value: "finished", label: "FINISHED" },
        { value: "dead_lead", label: "DEAD LEAD" },
    ];

    return (
        <>
            <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50">
                <div className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-w-full sm:tw-max-w-lg">
                    <div className="tw-px-4 tw-pt-5 tw-pb-4 sm:tw-p-6 sm:tw-pb-4">
                        <div className="tw-flex tw-flex-col tw-space-y-2">
                            {statusOptions.map((option, index) => (
                                <button
                                    className="tw-bg-transparent tw-border-0 tw-w-full tw-h-9 tw-mb-1 tw-text-left tw-px-2 tw-py-1 hover:tw-bg-gray-100"
                                    key={index}
                                    onClick={() => {
                                        closeModal(false);
                                    }}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

